var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 47,
    viewBox: "0 0 328 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.245 0.512756C320.825 0.512756 315.015 3.11276 310.815 7.31276C306.615 11.5128 304.005 17.3328 304.005 23.7528C304.005 36.5928 293.595 47.0028 280.755 47.0028H47.2449C40.8249 47.0028 35.0149 44.4028 30.8149 40.1928C26.6049 35.9828 24.0049 30.1728 24.0049 23.7528C24.0049 10.9128 13.5949 0.512756 0.754883 0.512756H327.245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiusIcon);
export default __webpack_public_path__ + "static/media/radius-icon.5fd12144f854998c47d01270228d8ec3.svg";
export { ForwardRef as ReactComponent };